<template>
  <Dialog
    v-model:visible="modelValue"
    modal
    :header="header"
    :style="{ width: '90vw', maxWidth: '800px' }"
    :closable="false"
  >
    <div class="flex items-start gap-4">
      <i
        v-if="showIcon"
        class="pi pi-info-circle !text-3xl mt-1"
      />
      <span
        v-if="message"
        v-html="message"
      />
    </div>
    <template #footer>
      <Button
        :label="buttonLabel"
        :icon="buttonIcon"
        @click="handleClose"
      />
    </template>
  </Dialog>
</template>

<script setup>
  const modelValue = defineModel();

  const props = defineProps({
    header: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    buttonIcon: {
      type: String,
      default: "pi pi-times"
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    buttonLabel: {
      type: String,
      default: "Close"
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  });

  const handleClose = () => {
    props.onClose();
    modelValue.value = false;
  };
</script>
